// extracted by mini-css-extract-plugin
export default {"content":"splash-screen_content__+4aJ-","logo":"splash-screen_logo__Aw4oO","main":"splash-screen_main__RbHYm","version":"splash-screen_version__qDqXm"};